export const programTrackTimes = {
  FULL_TIME: 'Full Time',
  PART_TIME: 'Part Time',
};

export const programTrackTypes = {
  COHORT: { value: 'cohort', label: 'Cohort' },
  ROLLING: { value: 'rolling', label: 'Rolling' },
};
